import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import color from '../utils/Colors';

export interface FeedbackCardItem {
  id: string;
  name: string;
  message: string;
  time: string;
}

interface FeedbackCardProps {
  items: FeedbackCardItem[];
}

const FeedbackCard: React.FC<FeedbackCardProps> = ({ items }) => {
  return (
    <Box
      sx={{
        backgroundColor: color.firstColor, 
        height: '400px',
        width:'300px',
        borderRadius:'16px',
        padding: 2,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: color.forthColor,
          borderRadius: '10px',
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5" color="white" sx={{fontWeight:'bold'}}>
          Feedback On Test Videos
        </Typography>
        <Typography variant="body2" color={color.secondColor}>
          {items.length} total
        </Typography>
      </Box>

      {items.length === 0 ? (
        <Typography variant="body2" color="white">
          No feedback yet.
        </Typography>
      ) : (
        items.map((item, index) => (
          <Card
            key={item.id}
            sx={{
              display: 'flex',
              alignItems: 'center',
              px: 1,
              mb: 1.5,
              backgroundColor: color.forthColor,
              borderRadius: '10px',
              maxWidth: '95%',
            }}
          >
            <Box
              sx={{
                backgroundColor:color.thirdColor,
                borderRadius: '8px',
                width: '40px',
                height: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
                fontWeight: 'bold',
              }}
            >
              {index + 1}
            </Box>

            <CardContent sx={{ py: 1 }}>
              <Typography variant="body1" color="white">
                {item.name}: {item.message}
              </Typography>
              <Typography variant="body2" color="#D3C1E1">
                {item.time}
              </Typography>
            </CardContent>
          </Card>
        ))
      )}
    </Box>
  );
};

export default FeedbackCard;
